import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UnitConversionService {
  private _currentUnit: 'km' | 'mi' = 'km';

  constructor() {
    this.setUnit((localStorage.getItem('UNIT') as 'km' | 'mi') ?? 'km');
  }

  get CurrentUnit(): 'km' | 'mi' {
    return this._currentUnit;
  }

  async setUnit(unit: 'km' | 'mi') {
    this._currentUnit = unit;
    return await localStorage.setItem('UNIT', unit);
  }
}
